import { useMediaQuery, useTheme } from '@mui/material';

// Below the theme's sm breakpoint (600 px) the board is the phone board: column
// tabs, one column at a time. From 600 px up it is today's grid.
export function useIsPhone(): boolean {
    const theme = useTheme();
    // noSsr: read matchMedia on the first render, so a phone never flashes the
    // desktop grid before switching.
    return useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
}
